import React from 'react';
import { Box, Modal, Fade, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ExpensesDetail from '../../../../Finance/ExpensesDetail';

// ดับเบิ้ลคลิกคอลัมน์ "รายละเอียด" → modal "รายละเอียดรายการเบิกจ่าย" ตัวเดียวกับ ExpensesTableApplove.js
export default function ExpenseDetailModal({ open, expenseId, onClose }) {
  return (
    <Modal open={open} onClose={onClose} closeAfterTransition>
      <Fade in={open}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '98%', sm: '95%', md: '90%', lg: '82%' },
            maxHeight: '95vh',
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              px: 2,
              py: 1,
              borderBottom: '1px solid',
              borderColor: 'divider',
              bgcolor: 'primary.main',
              color: 'white',
              flexShrink: 0,
            }}
          >
            <Typography variant="subtitle1" fontWeight="bold">
              รายละเอียดรายการเบิกจ่าย
            </Typography>
            <IconButton size="small" onClick={onClose} sx={{ color: 'white' }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
          <Box sx={{ overflowY: 'auto', flex: 1, p: { xs: 1, sm: 2 } }}>
            {expenseId && <ExpensesDetail propId={expenseId} onClose={onClose} />}
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}
